import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindMaterialTypesRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindMaterialTypesRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindMaterialTypesRequestSortsDto>>
}

export const MaterialTypesSort = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("admin")
  return (
    <SortBuilder<FindMaterialTypesRequestSortsDto>
      sorts={sorts}
      setSorts={setSorts}
      options={[
        {
          label: t("materialTypes.sort.originalText"),
          value: "originalText",
        },
        {
          label: t("materialTypes.sort.operationChainName"),
          value: "operationChainName",
        },
      ]}
    />
  )
}
